import React from 'react';

import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { formatTimespent, formatName } from "../../../../services/report.service";

import { Col, Row } from 'react-bootstrap';

import styles from "../../reports.module.scss";
import entityStyles from "./styles.module.scss";

import DefaultAssetIcon from '../../../../images/defaultAsset.jpg';
import numeral from 'numeral';
import Truncate from 'src/components/truncate';
import { localizedStrings } from "../../../../../localization/index"
import Tooltip from 'src/components/tooltip';


class ShareListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    const uniqueEmailOpens = _.get(this.props.item, 'share.uniqueEmailOpens', 0);
    const uniqueLinkClicks = _.get(this.props.item, 'share.uniqueLinkClicks', 0);
    const totalRecipients = _.get(this.props.item, 'totalRecipients', 1) || 1;

    return (
      <a href={`/conversations/${this.props.item.share.id}`} target='_blank' className={cx(styles.item, entityStyles.share, this.props.className)}>
        <img className={styles.icon} src={_.get(this.props.item, 'share.icon.thumbnail') || DefaultAssetIcon} />
        <div>
          <h5 className={styles.title}><Truncate width={300}>{_.get(this.props.item, 'share.subject')}</Truncate></h5>
          <ul className={styles.metrics}>
            <li>{numeral(uniqueEmailOpens / totalRecipients).format('0%')} {this.localizedTabsCommons.open_rate}</li>
            <li>{numeral(uniqueLinkClicks / totalRecipients).format('0%')} {this.localizedTabsCommons.click_rate}</li>
            <li>{formatTimespent(_.get(this.props.item, 'share.totalTimeSpent', 0))} {this.localizedTabsCommons.time_spent}</li>
          </ul>
          <div className={entityStyles.sharedBy}>{this.localizedTabsCommons.shared_by}: {formatName(this.props.item.createdBy)}</div>
        </div>
      </a>
    );
  }
}

class ShareGridItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    }

    this.localizedReport = localizedStrings.pages.reports;
    this.localizedTabsCommons = this.localizedReport.tabs.commons;
  }

  render() {
    var source = _.get(this.props.item, 'share.source', 'Link');
    if (source == "Paperflite QuickSend") {
      source = "Quick Send";
    } else if (source == "Paperflite Link") {
      source = "Link";
    }

    const uniqueEmailOpens = _.get(this.props.item, 'share.uniqueEmailOpens', 0);
    const uniqueLinkClicks = _.get(this.props.item, 'share.uniqueLinkClicks', 0);
    const totalRecipients = _.get(this.props.item, 'totalRecipients', 1) || 1;

    return (
      <Row className={cx(styles.row, entityStyles.share)}>
        <Col className={styles.column} md={4}>
          <a href={`/conversations/${this.props.item.share.id}`} target='_blank' className={cx(styles.item, this.props.className)}>
            <img className={styles.icon} src={_.get(this.props.item, 'share.icon.thumbnail') || DefaultAssetIcon} />
            <div className={styles.conversationActivityTitle}>
              <Tooltip content={_.get(this.props.item, 'share.subject')} placement="bottom">
                <h5 className={styles.title}>{_.get(this.props.item, 'share.subject')}</h5>
              </Tooltip>
              <ul className={styles.metrics}>
                <li>{_.get(this.props.item, 'totalAssetsCount')} {this.localizedTabsCommons.assets}</li>
                <li>{totalRecipients} {this.localizedTabsCommons.recipients}</li>
              </ul>
            </div>
          </a>
        </Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}><Truncate lines={2}>{formatName(this.props.item.createdBy)}</Truncate></Col>
        <Col className={cx(styles.column, entityStyles.value)} md={2}>{dateformat(this.props.item.share.createdDate, 'dd mmm yyyy')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={1}>{source}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={1}>{numeral(uniqueEmailOpens / totalRecipients).format('0%')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={1}>{numeral(uniqueLinkClicks / totalRecipients).format('0%')}</Col>
        <Col className={cx(styles.column, entityStyles.value)} md={1}>{formatTimespent(_.get(this.props.item, 'share.totalTimeSpent', 0))}</Col>
      </Row>
    );
  }
}

const Share = {};
Share.List = ShareListItem;
Share.Grid = ShareGridItem;

export default Share;